"use client";

import { createContext } from "react";

export const DrawerContext = createContext(false);
